import { Zap } from "lucide-react";

const WORDS = ["Zero Emissions", "Instant Torque", "Battery Activated Multi Force", "Grand Rapids, Michigan", "Uncompromised Performance", "Rescue & Tactical"];

export function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-obsidian py-6 md:py-8">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`font-display text-5xl md:text-7xl font-extrabold uppercase tracking-tight px-6 md:px-10 ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>
                <Zap className="h-7 w-7 md:h-10 md:w-10 text-volt fill-[var(--volt)]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
